import Image from "next/image"

interface BeforeAfterCoverProps {
  before: string
  after: string
  alt: string
}

export function BeforeAfterCover({ before, after, alt }: BeforeAfterCoverProps) {
  return (
    <div className="relative h-full w-full overflow-hidden">
      {/* Checkerboard transparency pattern (visible on the "after" side) */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(45deg, #e0e0e0 25%, transparent 25%), linear-gradient(-45deg, #e0e0e0 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e0e0e0 75%), linear-gradient(-45deg, transparent 75%, #e0e0e0 75%)",
          backgroundSize: "16px 16px",
          backgroundPosition: "0 0, 0 8px, 8px -8px, -8px 0",
        }}
      />

      {/* Before image — full width behind, but only visible on left half */}
      <Image
        src={before}
        alt={`${alt} — before`}
        fill
        className="object-cover"
        sizes="(max-width: 768px) 100vw, 50vw"
      />

      {/* Right half: checkerboard + after (cutout) overlay */}
      <div className="absolute inset-y-0 right-0 w-1/2 overflow-hidden">
        {/* Checkerboard behind cutout */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "linear-gradient(45deg, #e0e0e0 25%, transparent 25%), linear-gradient(-45deg, #e0e0e0 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e0e0e0 75%), linear-gradient(-45deg, transparent 75%, #e0e0e0 75%)",
            backgroundSize: "16px 16px",
            backgroundPosition: "0 0, 0 8px, 8px -8px, -8px 0",
          }}
        />
        {/* After image — positioned relative to full width so subject aligns */}
        <div className="absolute inset-y-0 -left-full right-0 w-[200%]">
          <Image
            src={after}
            alt={`${alt} — after`}
            fill
            className="object-cover"
            sizes="(max-width: 768px) 100vw, 50vw"
          />
        </div>
      </div>

      {/* Divider line */}
      <div className="absolute inset-y-0 left-1/2 w-0.5 -translate-x-1/2 bg-white shadow-sm" />

      {/* Drag handle */}
      <div className="absolute left-1/2 top-1/2 flex h-8 w-8 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white shadow-md">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          className="text-muted-foreground"
        >
          <path
            d="M4.5 3L1 7l3.5 4M9.5 3L13 7l-3.5 4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Labels */}
      <span className="absolute left-3 top-3 rounded-md bg-black/50 px-2.5 py-1 text-xs font-medium text-white">
        Before
      </span>
      <span className="absolute right-3 top-3 rounded-md bg-black/50 px-2.5 py-1 text-xs font-medium text-white">
        After
      </span>
    </div>
  )
}
